export const content = {
  userSettings: 'User Settings',
  logout: 'Logout',
  helpAndSupport: 'Help & Support',
  sendgridPreferences: 'SendGrid Preferences',
  setupGuide: 'Setup Guide',
};
